import { ENUM_QUALIFY_QUESTION_TYPES } from "../../../../enums";

const errObj = { question: "", options: "" };

const DEFAULT_QUESTIONS = [
  {
    field: "q1",
    question: "",
    isValid: false,
    type: ENUM_QUALIFY_QUESTION_TYPES.SHORT_TEXT,
    options: [],
    error: { ...errObj },
  },
  {
    field: "q2",
    question: "",
    isValid: false,
    type: ENUM_QUALIFY_QUESTION_TYPES.SHORT_TEXT,
    options: [],
    error: { ...errObj },
  },
  {
    field: "q3",
    question: "",
    isValid: false,
    type: ENUM_QUALIFY_QUESTION_TYPES.SHORT_TEXT,
    options: [],
    error: { ...errObj },
  },
];

const qualifyQuestionFormConfig = {
  questions: DEFAULT_QUESTIONS,
  setFormData(data?: Record<string, any>) {
    if (!data || !Object.keys(data).length) {
      return DEFAULT_QUESTIONS.map((q) => ({
        ...q,
        error: { ...errObj },
        options: [],
      }));
    }

    return Object.keys(data).map((q) => ({
      field: q,
      question: data[q]?.question || "",
      type: data[q]?.type || ENUM_QUALIFY_QUESTION_TYPES.SHORT_TEXT,
      options: data[q]?.options || [],
      error: { ...errObj },
      isValid: true,
    }));
  },
  runValidation(formData: any[], index?: number) {
    const arr = formData.map((fd, i) => {
      const shouldValidate = typeof index !== "number" || index === i;
      const questionError =
        shouldValidate && !fd.question ? `Question ${i + 1} is required` : "";
      const optionsError =
        shouldValidate &&
        fd?.type === ENUM_QUALIFY_QUESTION_TYPES.MULTI_SELECT &&
        !fd?.options?.length
          ? "Options are required"
          : "";

      const error = {
        ...fd.error,
        question: questionError,
        options: optionsError,
      };

      return {
        ...fd,
        error,
        isValid: error.question === "" && error.options === "",
      };
    });

    const isValid = arr.every(
      (a) => a.error.question === "" && a.error.options === ""
    );

    return { isValid, formData: arr };
  },
  generateQualifyingQuestionPayload(questionConfigFormData: any[]) {
    let payload: Record<string, any> = {};

    questionConfigFormData.forEach((q) => {
      payload = {
        ...payload,
        [q?.field]: {
          question: q?.question,
          type: q?.type,
          ...(q?.type === ENUM_QUALIFY_QUESTION_TYPES.MULTI_SELECT && {
            options: q?.options,
          }),
        },
      };
    });

    return payload;
  },
};

export { qualifyQuestionFormConfig };

export const QUALIFY_QUESTION_TYPE_OPTIONS = [
  { label: "Short text", value: ENUM_QUALIFY_QUESTION_TYPES.SHORT_TEXT },
  { label: "Yes/No", value: ENUM_QUALIFY_QUESTION_TYPES.BOOLEAN },
  { label: "Multi Select", value: ENUM_QUALIFY_QUESTION_TYPES.MULTI_SELECT },
];
